import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Used in conjunction with the Main page for displaying
 * error messages in a drop down panel.
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private notificationTextSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor() { }

  public publishNotificationText(text: string): void {
    this.notificationTextSubject.next(text);
  }

  public getNotificationText(): Observable<string> {
    return this.notificationTextSubject.asObservable();
  }
}
